var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "constructor",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "c-sidesheet",
        { attrs: { active: _vm.localActive }, on: { close: _vm.close } },
        [
          _c("div", { staticClass: "constructor__header" }, [
            _c("div", { staticClass: "constructor__header__title" }, [
              _vm._v("Новая должность"),
            ]),
          ]),
          _c("div", { staticClass: "constructor__description" }, [
            _vm._v("Все поля обязательны для заполнения"),
          ]),
          _c("div", { staticClass: "constructor__wrapper" }, [
            _c("div", { staticClass: "constructor__content" }, [
              _c(
                "form",
                {
                  staticClass: "new-position-form",
                  attrs: { action: "" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "new-position-form__row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "new-position-form__col new-position-form__name",
                      },
                      [
                        _c("c-input-2", {
                          class: {
                            "is-invalid": _vm.isSubmitted && _vm.nameError,
                          },
                          attrs: {
                            clearable: true,
                            "floating-label": "Наименование должности",
                            "max-length": 255,
                            required: _vm.isSubmitted && _vm.nameError,
                            "required-condition":
                              _vm.isSubmitted && _vm.nameError,
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "new-position-form__row" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "new-position-form__col new-position-form__code",
                        },
                        [
                          _c("c-input-2", {
                            class: {
                              "is-invalid": _vm.isSubmitted && _vm.codeError,
                            },
                            attrs: {
                              clearable: true,
                              "floating-label": "Код должности",
                              "label-full-name": "Код должности",
                              "max-length": 64,
                              required: _vm.isSubmitted && _vm.codeError,
                              "required-condition":
                                _vm.isSubmitted && _vm.codeError,
                            },
                            model: {
                              value: _vm.form.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "code", $$v)
                              },
                              expression: "form.code",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "new-position-form__col new-position-form__type",
                        },
                        [
                          _c("c-switcher-2", {
                            staticClass: "h-switcher",
                            attrs: {
                              type: "group",
                              items: _vm.dictionaries.types,
                            },
                            model: {
                              value: _vm.form.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.isProductionType
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "new-position-form__col new-position-form__group",
                              },
                              [
                                _c("c-input-2", {
                                  class: {
                                    "is-invalid":
                                      _vm.isSubmitted &&
                                      _vm.productionGroupError,
                                  },
                                  attrs: {
                                    "floating-label": "Группа должности",
                                    items: _vm.dictionaries.productionGroups,
                                    type: "select",
                                    searchable: true,
                                    clearable: true,
                                    required:
                                      _vm.isSubmitted &&
                                      _vm.productionGroupError,
                                    "required-condition":
                                      _vm.isSubmitted &&
                                      _vm.productionGroupError,
                                  },
                                  model: {
                                    value: _vm.form.productionGroup,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "productionGroup", $$v)
                                    },
                                    expression: "form.productionGroup",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _c("transition", { attrs: { name: "slide" } }, [
                    _vm.isProductionType
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "new-position-form__row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "new-position-form__col new-position-form__workload",
                                },
                                [
                                  _c("c-input-2", {
                                    class: {
                                      "is-invalid":
                                        _vm.isSubmitted &&
                                        _vm.workloadErrors.workloadType,
                                    },
                                    attrs: {
                                      "floating-label": "Тип нагрузки",
                                      "label-full-name": "Тип нагрузки",
                                      items:
                                        _vm.workloadDictionaries.workloadTypes,
                                      type: "select",
                                      searchable: true,
                                      clearable: true,
                                      required:
                                        _vm.isSubmitted &&
                                        _vm.workloadErrors.workloadType,
                                      "required-condition":
                                        _vm.isSubmitted &&
                                        _vm.workloadErrors.workloadType,
                                    },
                                    model: {
                                      value: _vm.workloadForm.workloadType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.workloadForm,
                                          "workloadType",
                                          $$v
                                        )
                                      },
                                      expression: "workloadForm.workloadType",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("transition", { attrs: { name: "fade" } }, [
                                _vm.workloadAdditionalParam === "orders"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "new-position-form__col new-position-form__order-types",
                                      },
                                      [
                                        _c("c-input-2", {
                                          attrs: {
                                            "floating-label": "Тип заказа",
                                            "label-full-name": "Тип заказа",
                                            type: "select",
                                            items:
                                              _vm.workloadDictionaries
                                                .orderTypes,
                                            multiple: true,
                                          },
                                          model: {
                                            value: _vm.workloadForm.orderTypes,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workloadForm,
                                                "orderTypes",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workloadForm.orderTypes",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                              _c("transition", { attrs: { name: "fade" } }, [
                                _vm.workloadAdditionalParam === "categories"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "new-position-form__col new-position-form__categories",
                                      },
                                      [
                                        _c("c-input-2", {
                                          staticClass:
                                            "positions-form-workload__item",
                                          attrs: {
                                            "floating-label": "Категории",
                                            "label-full-name": "Категории",
                                            type: "select",
                                            items:
                                              _vm.workloadDictionaries
                                                .categories,
                                            clearable: true,
                                            multiple: true,
                                            checkbox: true,
                                            "checkbox-type": "icon",
                                            "checkbox-value":
                                              _vm.workloadForm.categoriesExcept,
                                            "checkbox-tooltip": {
                                              disabledText:
                                                "Фильтр по всем категории, кроме выбранных",
                                              activeText:
                                                "Выключить фильтр по всем категории, кроме выбранных",
                                              notActiveText:
                                                "Включить фильтр по всем категории, кроме выбранных",
                                            },
                                          },
                                          on: {
                                            checkboxChange: function ($event) {
                                              _vm.workloadForm.categoriesExcept =
                                                $event
                                            },
                                          },
                                          model: {
                                            value: _vm.workloadForm.categories,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workloadForm,
                                                "categories",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workloadForm.categories",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "new-position-form__row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "new-position-form__col new-position-form__units",
                              },
                              [
                                _c("c-input-2", {
                                  class: {
                                    "is-invalid":
                                      _vm.isSubmitted &&
                                      _vm.workloadErrors.unitType,
                                  },
                                  attrs: {
                                    label: "Единицы",
                                    "label-full-name": "Единицы",
                                    items: _vm.workloadDictionaries.unitTypes,
                                    type: "select",
                                    disabled: _vm.workloadBlockUnits,
                                    required:
                                      _vm.isSubmitted &&
                                      _vm.workloadErrors.unitType,
                                    "required-condition":
                                      _vm.isSubmitted &&
                                      _vm.workloadErrors.unitType,
                                  },
                                  model: {
                                    value: _vm.workloadForm.unitType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.workloadForm,
                                        "unitType",
                                        $$v
                                      )
                                    },
                                    expression: "workloadForm.unitType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.workloadForm.workloadType &&
                            _vm.workloadForm.workloadType.quantitativeIndicator
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "new-position-form__col new-position-form__standard-type",
                                  },
                                  [
                                    _c("number-value", {
                                      attrs: {
                                        label: "Норматив выработки",
                                        "full-label": "Норматив выработки",
                                        unit: _vm.workloadUnitName,
                                        error:
                                          _vm.isSubmitted &&
                                          _vm.workloadErrors.productionStandard,
                                      },
                                      model: {
                                        value:
                                          _vm.workloadForm.productionStandard,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.workloadForm,
                                            "productionStandard",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "workloadForm.productionStandard",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "new-position-form__row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "new-position-form__col new-position-form__fix-daily-salary",
                              },
                              [
                                _c("c-input-2", {
                                  class: {
                                    "is-invalid":
                                      _vm.isSubmitted &&
                                      _vm.fixDailySalaryError,
                                  },
                                  attrs: {
                                    label: "Фикс. дневной оклад, ฿",
                                    "label-full-name":
                                      "Фиксированный дневной оклад сотрудника, в ฿",
                                    type: "price-number",
                                    placeholder: "0",
                                    split: true,
                                    "max-length": 15,
                                    "fractional-length": 0,
                                    required:
                                      _vm.isSubmitted &&
                                      _vm.fixDailySalaryError,
                                    "required-condition":
                                      _vm.isSubmitted &&
                                      _vm.fixDailySalaryError,
                                  },
                                  model: {
                                    value: _vm.form.fixDailySalary,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "fixDailySalary", $$v)
                                    },
                                    expression: "form.fixDailySalary",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _c("transition", { attrs: { name: "slide" } }, [
                    !_vm.isProductionType
                      ? _c("div", [
                          _c("div", { staticClass: "new-position-form__row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "new-position-form__col new-position-form__route-type",
                              },
                              [
                                _c("c-input-2", {
                                  attrs: {
                                    label: "Тип маршрута",
                                    "label-full-name": "Тип маршрута",
                                    items: _vm.dictionaries.routeTypes,
                                    type: "select",
                                  },
                                  model: {
                                    value: _vm.form.routeType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "routeType", $$v)
                                    },
                                    expression: "form.routeType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "new-position-form__col new-position-form__cost-per-minute",
                              },
                              [
                                _c("c-input-2", {
                                  class: {
                                    "is-invalid":
                                      _vm.isSubmitted && _vm.costPerMinError,
                                  },
                                  attrs: {
                                    label: "Рабочее время, ฿/мин",
                                    "label-full-name": "Рабочее время, ฿/мин",
                                    type: "price-number",
                                    placeholder: "0",
                                    split: true,
                                    "max-length": 15,
                                    "fractional-length": 0,
                                    required:
                                      _vm.isSubmitted && _vm.costPerMinError,
                                    "required-condition":
                                      _vm.isSubmitted && _vm.costPerMinError,
                                  },
                                  model: {
                                    value: _vm.form.costPerMin,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "costPerMin", $$v)
                                    },
                                    expression: "form.costPerMin",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "new-position-form__col new-position-form__cost-per-order",
                              },
                              [
                                _c("c-input-2", {
                                  class: {
                                    "is-invalid":
                                      _vm.isSubmitted && _vm.costPerOrderError,
                                  },
                                  attrs: {
                                    label: "Доставка 1 заказа, ฿",
                                    "label-full-name": "Доставка 1 заказа, ฿",
                                    type: "price-number",
                                    placeholder: "0",
                                    split: true,
                                    "max-length": 15,
                                    "fractional-length": 0,
                                    required:
                                      _vm.isSubmitted && _vm.costPerOrderError,
                                    "required-condition":
                                      _vm.isSubmitted && _vm.costPerOrderError,
                                  },
                                  model: {
                                    value: _vm.form.costPerOrder,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "costPerOrder", $$v)
                                    },
                                    expression: "form.costPerOrder",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "new-position-form__col new-position-form__cost-per-km",
                              },
                              [
                                _c("c-input-2", {
                                  class: {
                                    "is-invalid":
                                      _vm.isSubmitted && _vm.costPerKmError,
                                  },
                                  attrs: {
                                    label: "1 км в пути, ฿",
                                    "label-full-name": "1 км в пути, ฿",
                                    type: "price-number",
                                    placeholder: "0",
                                    "max-length": 15,
                                    split: true,
                                    "fractional-length": 0,
                                    required:
                                      _vm.isSubmitted && _vm.costPerKmError,
                                    "required-condition":
                                      _vm.isSubmitted && _vm.costPerKmError,
                                  },
                                  model: {
                                    value: _vm.form.costPerKm,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "costPerKm", $$v)
                                    },
                                    expression: "form.costPerKm",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "new-position-form__actions" },
                    [
                      _c("c-button", {
                        staticClass: "new-position-form__reset",
                        attrs: { size: "large", label: "Отменить" },
                        on: { click: _vm.close },
                      }),
                      _c("c-button", {
                        staticClass: "new-position-form__apply",
                        attrs: {
                          size: "large",
                          color: "primary",
                          label: "Сохранить и перейти к настройке",
                          type: "submit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }